/**
 * Category and Tag Service
 * Handles category and tag management operations
 */

import { apiClient, handleApiError } from './apiClient';
import { USERS_API_BASE_URL } from '../constants';

/**
 * Get category tags for an organization
 * @param orgId - Organization ID
 * @param authToken - Authentication token
 * @returns Promise with category tags
 * @throws ApiError if request fails
 */
export const getCategoryTags = async (
  orgId: string,
  authToken: string
): Promise<any> => {
  try {
    const response = await apiClient.get(
      `${USERS_API_BASE_URL}/category/${orgId}`,
      {
        headers: { Authorization: authToken },
      }
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Add new tag
 * @param body - Tag creation data
 * @param authToken - Authentication token
 * @returns Promise with created tag
 * @throws ApiError if creation fails
 */
export const addNewTag = async (
  body: any,
  authToken: string
): Promise<any> => {
  try {
    const response = await apiClient.post(
      `${USERS_API_BASE_URL}/tag`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: authToken,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};

/**
 * Add new category (admin only)
 * @param body - Category creation data
 * @param authToken - Authentication token
 * @returns Promise with created category
 * @throws ApiError if creation fails
 */
export const addNewCategory = async (
  body: any = '',
  authToken: string
): Promise<any> => {
  try {
    const response = await apiClient.post(
      `${USERS_API_BASE_URL}/category/admin`,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: authToken,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw handleApiError(error);
  }
};
